<template>
  <fieldset>
    <FormulateInput
      name="reasonofterminationcost"
      :options="{
        tooexpensive: i18n.form.labels.reasonofterminationcostoptions.tooexpensive,
        cannotpay: i18n.form.labels.reasonofterminationcostoptions.cannotpay,
        other: i18n.form.labels.reasonofterminationcostoptions.other,
      }"
      type="radio"
      :label="i18n.form.labels.reasonofterminationcost"
      validation="required"
      :validation-messages="i18n.form.validations.reasonofterminationcost"
    />
    <FormulateInput
      v-if="showReasonInput"
      name="reasonofterminationcostotherreason"
      type="textarea"
      validation="bail|required|nohtml"
      :validation-messages="i18n.form.validations.reasonofterminationcostotherreason"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsReasonOfTerminationCost',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    model: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    showReasonInput() {
      return this.model.reasonofterminationcost === 'other';
    },
  },
};
</script>
